import React from 'react';
import { useNavigate } from 'react-router-dom';
import BackIcon from 'assets/back_button_img.svg?react';
import styled from 'styled-components';

const BackButton = (props) => {
  const {
    isMobileDialog,
    isInfoBlockVisible,
    setIsInfoBlockVisible,
    isPrivate,
  } = props;

  const navigate = useNavigate();
  const navigateTo = isPrivate ? '/?mode=private' : '/#featured-scenarios';
  const handleBackClick = () => {
    if (isInfoBlockVisible) {
      setIsInfoBlockVisible(false);
      return;
    }
    navigate(navigateTo);
    window.setTimeout(() => {
      const position = document.getElementById('featured-scenarios').offsetTop;
      window.scrollTo({ top: position - 100, behavior: 'smooth' });
    }, 700);
  };

  return (
    <>
      {!isMobileDialog && (
        <Root onClick={handleBackClick} className="mr-4">
          <BackIcon />
        </Root>
      )}

      {isMobileDialog && (
        <Root onClick={handleBackClick}>
          <BackIcon />
        </Root>
      )}
    </>
  );
};

export default BackButton;

const Root = styled.div`
  cursor: pointer;
  border-radius: 50%;
  min-width: 40px;
  width: 40px;
  height: 40px;
  background-color: rgba(28, 28, 28, 1);
  display: flex;
  align-items: center;
  justify-content: center;
`;
